export class Section {
  constructor(id, title, titleLong, content) {
    this.id = id;
    this.title = title;
    this.titleLong = titleLong;
    this.content = content;
  }
}
